var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Books")]),_vm._l((_vm.books),function(book){return _c('book-item',{key:book.id,attrs:{"book":book}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }